import { useAtom, useSetAtom, useAtomValue, atom } from "jotai";
import {
  labelsAtom,
  inputTextSearchAtom,
  toolsExperienceAtom,
  toolsExperienceOptionViewsAtom,
  projectTypeAtom,
  offeredGratificationAtom,
  forGratificationAtom,
  softSkillsAtom,
  requiredAreaOfExpertiseAtom,
  projectDeadlineAtom,
  hardSkillsAtom,
  offeredWorkingTypeAtomNewArray,
  offeredWorkingTypeActiveOptionsAtom,
  usedLanguagesAtom,
  bizOrTechRoleAtomLeftValue,
  bizOrTechRoleAtomRightValue,
  requiredAvailabilityAtomStartValue,
  requiredAvailabilityAtomEndValue,
  requiredAvailabilityAtomOption,
  projectDeadlineAtomOption,
  locationsAtom,
  productTypeAtom,
} from "./atom/ProjectFiltersAtom";

import { projectsAtom,hasMoreProjectsAtom,indexAtom } from "../../pages/Projects/atoms/ProjectAtomGlobal";

import "../../sass/components/ProjectFilters/Layout.scss";
import ToolsExperienceFilter from "../Filters_Projects/ToolsExperienceFilter";
import ProjectType from "../Filters_Projects/ProjectTypeFilter";
import OfferredGratification from "../Filters_Projects/OfferedGratificationFilter";
import ForGratification from "../Filters_Projects/ForGratificationFilter";
import AreaOfExperties from "../Filters_Projects/AreaOfExpertiesFilter";
import ProjectDeadline from "../Filters_Projects/ProjectDeadlineFilter";
import OfferedWorkingType from "../Filters_Projects/OfferedWorkingTypeFilter";
import Availability from "../Filters_Projects/RequiredAvailabilityFilter";
import BizOrTechRole from "../Filters_Projects/RequiredBizOrTechRoleFilter";

import InputTextSearchFilter from "../Filters_Projects/InputTextSearchFilter";
import ProductTypeFilter from '../Filters_Projects/ProductTypeFilter';

import { Button } from "@mui/material";
import { useDataFromProjectFilters } from "../../utils/useDataFromProjectFilters";
import { url } from "../../url";
import axios from "axios";
import tools_tools from "../../data/projects/enums/projects_tools_tools";
import { openAtom } from "../../components/ProjectFilters/atom/ProjectFiltersAtom";
import { useOpenCloseFiltersFromProjectFilters } from "../../utils/useOpenCloseFiltersFromProjectFilters";
import React, { useState, useEffect } from "react";
import { HardSkillsFilter, SoftSkillsFilter, LocationFilter, UsedLanguagesFilter } from "../common";
import { FILTERS } from '../../filters/filtersConfig';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import { Tabs, Tab } from '@mui/material';

/** DODANE: Funkcja do pobierania posortowanych projektów z Flask */
async function fetchSortedProjects(filter: any) {
  console.log("[MAGIC_SORT] fetchSortedProjects called", filter);
  const res = await fetch("https://embedding-api-dot-smart-setting-448914-d9.lm.r.appspot.com/sort", { // TODO Change urls for prod in .env
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ type: "project", filter }),
  });
  return await res.json();
}

const MAGIC_SORT = false; // Ustaw na false, by używać klasycznego filtrowania

interface ProjectFiltersProps {
  onDisplayJson?: (jsonData: any) => void;
  onCloseFilters?: () => void;
}

// Atom do wyboru typu wyszukiwania
export const lookForAtom = atom<'all' | 'projects' | 'teammates'>('projects');

const ProjectFilters = ({ onDisplayJson, onCloseFilters }: ProjectFiltersProps) => {
  const [labels, setLabels] = useAtom(labelsAtom);  // Store predicted labels
  const [inputTextSearch, setInputTextSearch] = useAtom(inputTextSearchAtom);  // Search text input
  
  const handleSearch = async () => {
    console.log("[FILTERS] handleSearch called");
    if (inputTextSearch.trim() !== "") {
      try {
        // LOCAL
        const response = await axios.post(url + "/ml", {
          input_text: inputTextSearch,
          len_2_cnt: 2
        });
        const result = response.data.similar_labels_dict;
        setLabels(result);  // Store full response for display
        // NEW: Update filters dynamically with API response
        updateFilters(result);
        // Po zakończeniu predykcji automatycznie odpal applyFilters
        await applyFilters();
      } catch (error) {
        console.error('Error fetching predictions:', error);
      }
    } else {
      // Jeśli nie ma tekstu, po kliknięciu Adjust Filters też odpal applyFilters
      await applyFilters();
    }
  };
  
  // NEW: Map API response to filter atoms
  const updateFilters = (result: Record<string, string[]>) => {
    console.log("[FILTERS] updateFilters called", result);
    const filterMapping: Record<string, any> = {
      toolsExperience: setToolsExperience,
      projectType: setProjectType,
      // ####### MODEL WAS TRAINED IN WRONG WAY, WE NEED TO SWAP HARD AND SOFT SKILLS. CHANGE IT BACK AFTER RETRAINING
      hardSkills: setSoftSkills,        // Zamiana: model AI wysyła role do softSkills, ale mapujemy do hardSkills (Target Roles)
      softSkills: setHardSkills,        // Zamiana: model AI wysyła soft skills do hardSkills, ale mapujemy do softSkills
      // ####### 
      requiredAreaOfExpertise: setRequiredAreaOfExpertise,
      offeredGratification: setOfferedGratification,
      forGratification: setForGratification,
      usedLanguages: setUsedLanguages,
      locations: setLocations,
      productType: setProductType,
    };
  
    Object.entries(result).forEach(([key, values]) => {
      if (filterMapping[key]) {
        console.log(`Updating ${key} with`, values);
        filterMapping[key]((prev: string[]) => [...values]);
      } else {
        console.warn(`No atom found for key: ${key}`);
      }
    });
  };
  

  const [index, setIndex] = useAtom(indexAtom);
  const [HasMoreProjects, setHasMoreProjects] = useAtom<boolean>(hasMoreProjectsAtom);
  const [toolsExperience, setToolsExperience] = useAtom(toolsExperienceAtom);
  const [toolsExperienceOptionViews, setToolsExperienceOptionViews] = useAtom(
    toolsExperienceOptionViewsAtom,
  );
  const [projectType, setProjectType] = useAtom(projectTypeAtom);
  const [offeredGratification, setOfferedGratification] = useAtom(
    offeredGratificationAtom,
  );
  const [softSkills, setSoftSkills] = useAtom(
    softSkillsAtom,
  );
  const [requiredAreaOfExpertise, setRequiredAreaOfExpertise] = useAtom(
    requiredAreaOfExpertiseAtom,
  );
  const [forGratification, setForGratification] = useAtom(forGratificationAtom);
  const [projectDeadline, setProjectDeadline] = useAtom(projectDeadlineAtom);
  const [hardSkills, setHardSkills] = useAtom(hardSkillsAtom);
  const [offeredWorkingTypeNewArray, setOfferedWorkingTypeNewArray] = useAtom(
    offeredWorkingTypeAtomNewArray,
  );
  const [offeredWorkingTypeActiveOptions, setOfferedWorkingTypeActiveOptions] =
    useAtom(offeredWorkingTypeActiveOptionsAtom);
  const [usedLanguages, setUsedLanguages] = useAtom(usedLanguagesAtom);
  const [bizOrTechRoleLeftValue, setBizOrTechRoleLeftValue] = useAtom(
    bizOrTechRoleAtomLeftValue,
  );
  const [bizOrTechRoleRightValue, setBizOrTechRoleRightValue] = useAtom(
    bizOrTechRoleAtomRightValue,
  );
  const [requiredAvailabilityStartValue, setRequiredAvailabilityStartValue] =
    useAtom(requiredAvailabilityAtomStartValue);
  const [requiredAvailabilityEndValue, setRequiredAvailabilityEndValue] =
    useAtom(requiredAvailabilityAtomEndValue);
  const [requiredAvailabilityOption, setRequiredAvailabilityOption] = useAtom(
    requiredAvailabilityAtomOption,
  );
  const [projectDeadlineOption, setProjectDeadlineOption] = useAtom(
    projectDeadlineAtomOption,
  );
  const [locations, setLocations] = useAtom(locationsAtom);
  const [productType, setProductType] = useAtom(productTypeAtom);
  const [lookFor, setLookFor] = useAtom(lookForAtom);
  console.log('productType:', productType);
  const openFilters = useAtomValue(openAtom)
  const enableAndResetFilters = useOpenCloseFiltersFromProjectFilters();
  // Usuń wszelkie odwołania do infoMsg, setInfoMsg, oraz renderowanie komunikatu w tym pliku.

  const setProjects = useSetAtom(projectsAtom);
  const query = useDataFromProjectFilters();

  const applyFilters = async () => {
    console.log("[FILTERS] applyFilters called");
    // Log active filters
    const activeFilters: any = {};
    if (toolsExperience.length > 0) activeFilters.toolsExperience = toolsExperience;
    if (projectType.length > 0) activeFilters.projectType = projectType;
    if (offeredGratification.length > 0) activeFilters.offeredGratification = offeredGratification;
    if (forGratification.length > 0) activeFilters.forGratification = forGratification;
    if (softSkills.length > 0) activeFilters.softSkills = softSkills;
    if (requiredAreaOfExpertise.length > 0) activeFilters.requiredAreaOfExpertise = requiredAreaOfExpertise;
    if (projectDeadline > 0) activeFilters.collaborationDuration = projectDeadline;
    if (hardSkills.length > 0) activeFilters.hardSkills = hardSkills;
    if (offeredWorkingTypeNewArray.length > 0) activeFilters.offeredWorkingType = offeredWorkingTypeNewArray;
    if (offeredWorkingTypeActiveOptions.length > 0) activeFilters.offeredWorkingTypeActiveOptions = offeredWorkingTypeActiveOptions;
    if (usedLanguages.length > 0) activeFilters.usedLanguages = usedLanguages;
    if (locations.length > 0) activeFilters.locations = locations;
    if (productType.length > 0) {
      activeFilters.productType = productType;
      activeFilters.product_type = productType;
    }
    if (requiredAvailabilityStartValue > 0) activeFilters.availability = requiredAvailabilityStartValue;

    try {
      // Nowe: wysyłaj do /project/traditional_filtering_all
      const res = await axios.post(url + "/project/traditional_filtering_all", {
        activeFilters: activeFilters,
        filtering_restriction: 'min_1_match'
      }, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const items = res.data.items || [];
      if (items.length > 0) {
        if (onDisplayJson) {
          onDisplayJson({ items });
        } else {
          setProjects(items.filter((item: any) => item.projectName));
        }
        setHasMoreProjects(false);
        setIndex(2);
      } else {
        // MAGIC SORT fallback: wywołaj Flask osobno dla projektów i teammateów
        const [magicProjects, magicTeammates] = await Promise.all([
          fetch("https://embedding-api-dot-smart-setting-448914-d9.lm.r.appspot.com/sort", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ type: "project", filter: activeFilters }),
          }).then(res => res.json()),
          fetch("https://embedding-api-dot-smart-setting-448914-d9.lm.r.appspot.com/sort", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ type: "teammate", filter: activeFilters }),
          }).then(res => res.json()),
        ]);
        // Pobierz wszystkie projekty i teammateów, żeby dopasować po _id
        const [allProjectsRes, allTeammatesRes] = await Promise.all([
          axios.get(url + "/project"),
          axios.get(url + "/teammate"),
        ]);
        const allProjects = allProjectsRes.data.projects || [];
        const allTeammates = allTeammatesRes.data.teammates || [];
        // Dopasuj wyniki AI po _id
        const sortedProjects = (magicProjects.results || []).map((result: any) => {
          const project = allProjects.find((p: any) => p._id === result.record_id);
          if (!project) return null;
          return { ...project, similarity: result.similarity };
        }).filter(Boolean);
        const sortedTeammates = (magicTeammates.results || []).map((result: any) => {
          const teammate = allTeammates.find((t: any) => t._id === result.record_id);
          if (!teammate) return null;
          return { ...teammate, similarity: result.similarity };
        }).filter(Boolean);
        if (onDisplayJson) {
          onDisplayJson({ items: [...sortedProjects, ...sortedTeammates] });
        } else {
          setProjects(sortedProjects);
          setTeammates(sortedTeammates);
        }
        setHasMoreProjects(false);
        setIndex(2);
      }
    } catch (error) {
      console.error("Traditional filtering ALL error:", error);
    }
  };

  const clearFilters = async () => {
    console.log("[FILTERS] clearFilters called");
    setToolsExperience([]);
    setToolsExperienceOptionViews(
      tools_tools.reduce((acc: any, option: string) => {
        acc[option] = 1; // Initialize views for each option to 1
        return acc;
      }, {}),
    );
    setProjectType([]);
    setOfferedGratification([]);
    setSoftSkills([]);
    setRequiredAreaOfExpertise([]);
    setForGratification([]);
    setProjectDeadline(new Date(0));
    setHardSkills([]);
    setOfferedWorkingTypeNewArray([]);
    setOfferedWorkingTypeActiveOptions([]);
    setUsedLanguages([]);
    setBizOrTechRoleLeftValue("");
    setBizOrTechRoleRightValue("");
    setRequiredAvailabilityStartValue(0);
    setRequiredAvailabilityEndValue(0);
    setRequiredAvailabilityOption("");
    setProjectDeadlineOption("");
    setLocations([]);
    setProductType([]);
    
    // Pobierz wszystkie projekty po wyczyszczeniu filtrów
    try {
      const res = await axios.get(url + "/project?page=1");
      
      // Użyj displayJson jeśli dostępne, w przeciwnym razie użyj setProjects
      if (onDisplayJson) {
        onDisplayJson(res.data);
      } else {
        setProjects(res.data.projects);
      }
      
      setHasMoreProjects(true);
      setIndex(2);
    } catch (error) {
      console.error("Error fetching all projects:", error);
    }
    
    setInputTextSearch("");
  };

  const filterLabelStyle = {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600,
    fontSize: 16,
    color: '#222',
    marginBottom: 4,
  };
  const radioStyle = {
    color: '#1976d2',
    '&.Mui-checked': { color: '#1976d2' },
    transform: 'scale(1.35)',
    padding: '8px',
  };
  const radioLabelStyle = {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600,
    fontSize: 16,
    color: '#222',
    padding: '0 18px 0 4px',
  };

  // Responsywny tekst przycisku Adjust
  const [adjustText, setAdjustText] = useState('Adjust Filters');
  useEffect(() => {
    const handleResize = () => {
      setAdjustText(window.innerWidth < 1450 ? 'Adjust' : 'Adjust Filters');
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="projects__body__container__left__card">
      
      {/* Zakładki Look For na górze */}
      <div className="filters-bar-main" style={{ display: 'flex', flexDirection: 'row', width: '80%', margin: '0 auto 8px auto', height: 22 }}>
        <div style={{ width: '25%', minWidth: 120, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Tabs
            value={lookFor}
            onChange={(_, value) => setLookFor(value)}
            aria-label="look for tabs"
            variant="standard"
            TabIndicatorProps={{ style: { background: '#1976d2', height: 4, borderRadius: 2 } }}
            sx={{
              minHeight: 44,
              height: 44,
              lineHeight: '44px',
              display: 'flex',
              alignItems: 'center',
              background: 'none',
              borderRadius: '16px',
              boxShadow: '0 2px 8px 0 rgba(21,101,192,0.07)',
              pl: 1.5,
              minWidth: 320,
              flexShrink: 0,
              margin: 0,
              padding: 0,
              position: 'relative',
              top: '-2px',
            }}
          >
            {/* <Tab
              value="all"
              label={<span style={{ fontWeight: 700, fontSize: 16, fontFamily: 'Montserrat, sans-serif', color: lookFor === 'all' ? '#1976d2' : '#222', letterSpacing: 0.5 }}>All</span>}
              sx={{
                minWidth: 140,
                minHeight: 44,
                px: 3,
                borderRadius: '12px 0 0 12px',
                background: lookFor === 'all' ? '#fff' : 'transparent',
                transition: 'background 0.2s',
              }}
            /> */}
            <Tab
              value="projects"
              label={<span style={{ fontWeight: 700, fontSize: 12, fontFamily: 'Montserrat, sans-serif', color: lookFor === 'projects' ? '#1976d2' : '#222', letterSpacing: 0.5 }}>Projects</span>}
              sx={{
                minWidth: 80,
                minHeight: 22,
                px: 1,
                borderRadius: '6px 0 0 6px',
                background: lookFor === 'projects' ? '#fff' : 'transparent',
                transition: 'background 0.2s',
              }}
            />
            <Tab
              value="teammates"
              label={<span style={{ fontWeight: 700, fontSize: 12, fontFamily: 'Montserrat, sans-serif', color: lookFor === 'teammates' ? '#1976d2' : '#222', letterSpacing: 0.5 }}>Teammates</span>}
              sx={{
                minWidth: 80,
                minHeight: 22,
                px: 1,
                borderRadius: '0 6px 6px 0',
                background: lookFor === 'teammates' ? '#fff' : 'transparent',
                transition: 'background 0.2s',
              }}
            />
          </Tabs>
        </div>
        <div style={{ width: '75%', display: 'flex', alignItems: 'center', gap: 6 }}>
          <div style={{ width: '85%' }}>
            <input
              className='search-input-box'
              type="text"
              value={inputTextSearch}
              onChange={(e) => setInputTextSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSearch();  // Trigger search on Enter
              }}
              placeholder="Write what you want to build, who do you need, what skills, whatever..."
              style={{
                width: '100%',
                height: '36px',
                borderRadius: '8px',
                background: '#fff',
                border: '1px solid #90caf9',
                fontSize: '12px',
                fontFamily: 'Montserrat, sans-serif',
                padding: '0 12px',
                margin: 0,
                boxSizing: 'border-box',
                lineHeight: '36px',
                verticalAlign: 'middle',
                outline: 'none',
                boxShadow: 'none',
                display: 'flex',
                alignItems: 'center',
              }}
            />
          </div>
          <div style={{ width: '15%' }}>
            <button
              className="apply_button"
              onClick={async () => { await handleSearch(); await applyFilters(); }}
              style={{
                height: '36px',
                lineHeight: '36px',
                borderRadius: '8px',
                padding: '0 16px',
                width: '100%',
                margin: 0,
                minWidth: 120,
                maxWidth: 150,
                fontSize: '11px',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                fontFamily: 'Montserrat, sans-serif',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxSizing: 'border-box',
              }}
            >
              {adjustText}
            </button>
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 1450px) {
          .filters-bar-main {
            flex-direction: column !important;
            height: auto !important;
            gap: 12px !important;
            align-items: center !important;
            justify-content: center !important;
          }
          .filters-bar-main > div {
            width: 100% !important;
            justify-content: center !important;
            display: flex !important;
          }
        }
        @media (max-width: 800px) {
          .filters-bar-main .MuiTabs-root .MuiTab-root {
            min-width: 80px !important;
            font-size: 12px !important;
            padding: 6px !important;
            height: 32px !important;
          }
          .filters-bar-main .MuiTabs-root {
            min-width: 240px !important;
          }
          .filters-bar-main .apply_button {
            min-width: 80px !important;
            font-size: 9px !important;
            padding: 0 8px !important;
            height: 32px !important;
            letter-spacing: 0 !important;
            font-weight: 600 !important;
            font-size: 10px !important;
            text-overflow: ellipsis !important;
            overflow: hidden !important;
            white-space: nowrap !important;
          }
          .filters-bar-main .search-input-box {
            height: 32px !important;
            font-size: 13px !important;
            padding: 0 10px !important;
          }
        }
      `}</style>
      <div className="filter-content">
        <div className='filter-container'>
          {/* 1. Product Type */}
          <div className={`filter-box-container ${productType.length > 0 ? 'selected' : ''}`}>
            <ProductTypeFilter
              pickedOptions={productType}
              setPickedOptions={setProductType}
              show={openFilters.productType}
              setShow={enableAndResetFilters}
              displayColumn={true}
              title={FILTERS.productType.label}
            />
          </div>

          {/* 2. Project Type */}
          <div className={`filter-box-container ${projectType.length > 0 ? 'selected' : ''}`}>
            <ProjectType
              pickedOptions={projectType}
              setPickedOptions={setProjectType}
              show={openFilters.projectType}
              setShow={enableAndResetFilters}
              displayColumn={true}
              title={FILTERS.projectType.label}
            />
          </div>

          {/* 3. Area of Expertise */}
          <div className={`filter-box-container ${requiredAreaOfExpertise.length > 0 ? 'selected' : ''}`}>
            <AreaOfExperties
              pickedOptions={requiredAreaOfExpertise}
              setPickedOptions={setRequiredAreaOfExpertise}
              show={openFilters.requiredAreaOfExpertise}
              setShow={enableAndResetFilters}
              displayColumn={true}
              title={FILTERS.industry.label}
            />
          </div>

          {/* 4. Hard Skills */}
          <div className={`filter-box-container ${hardSkills.length > 0 ? 'selected' : ''}`}>
            <HardSkillsFilter
              pickedOptions={hardSkills}
              setPickedOptions={setHardSkills}
              show={openFilters.hardSkills}
              setShow={enableAndResetFilters}
              displayColumn={true}
              title={FILTERS.hardSkills.label}
            />
          </div>

          {/* 5. Soft Skills */}
          <div className={`filter-box-container ${softSkills.length > 0 ? 'selected' : ''}`}>
            <SoftSkillsFilter
              pickedOptions={softSkills}
              setPickedOptions={setSoftSkills}
              show={openFilters.softSkills}
              setShow={enableAndResetFilters}
              displayColumn={true}
              title={FILTERS.softSkills.label}
            />
          </div>

          {/* 6. Tools Experience */}
          <div className={`filter-box-container ${toolsExperience.length > 0 ? 'selected' : ''}`}>
            <ToolsExperienceFilter
              pickedOptions={toolsExperience}
              setPickedOptions={setToolsExperience}
              optionViews={toolsExperienceOptionViews}
              setOptionViews={setToolsExperienceOptionViews}
              show={openFilters.toolsExperience}
              setShow={enableAndResetFilters}
              displayColumn={true}
              title={FILTERS.toolsExperience.label}
            />
          </div>

          {/* 7. Used Languages */}
          <div className={`filter-box-container ${usedLanguages.length > 0 ? 'selected' : ''}`}>
            <UsedLanguagesFilter
              pickedOptions={usedLanguages}
              setPickedOptions={setUsedLanguages}
              show={openFilters.usedLanguages}
              setShow={enableAndResetFilters}
              displayColumn={true}
              title={FILTERS.usedLanguages.label}
            />
          </div>

          {/* 8. Location */}
          <div className={`filter-box-container ${locations.length > 0 ? 'selected' : ''}`}>
            <LocationFilter
              pickedOptions={locations}
              setPickedOptions={setLocations}
              show={openFilters.locations}
              setShow={enableAndResetFilters}
              displayColumn={true}
              title={FILTERS.locations.label}
            />
          </div>

          {/* 9. Required Availability */}
          <div className={`filter-box-container ${requiredAvailabilityStartValue || requiredAvailabilityEndValue ? 'selected' : ''}`}>
            <Availability
              startValue={requiredAvailabilityStartValue}
              setStartValue={setRequiredAvailabilityStartValue}
              endValue={requiredAvailabilityEndValue}
              setEndValue={setRequiredAvailabilityEndValue}
              selectedOption={requiredAvailabilityOption}
              setSelectedOption={setRequiredAvailabilityOption}
              open={openFilters.requiredAvailability}
              setOpen={enableAndResetFilters}
              title={FILTERS.requiredAvailability.label}
            />
          </div>

          {/* 10. Offered Working Type */}
          <div className={`filter-box-container ${offeredWorkingTypeNewArray.length > 0 ? 'selected' : ''}`}>
            <OfferedWorkingType
              activeOptions={offeredWorkingTypeActiveOptions}
              setActiveOptions={setOfferedWorkingTypeActiveOptions}
              newArray={offeredWorkingTypeNewArray}
              setNewArray={setOfferedWorkingTypeNewArray}
              show={openFilters.offeredWorkingType}
              setShow={enableAndResetFilters}
              title={FILTERS.offeredWorkingType.label}
            />
          </div>

          {/* 11. Project Deadline */}
          <div className={`filter-box-container ${Number(projectDeadline) > 0 ? 'selected' : ''}`}>
            <ProjectDeadline
              value={Number(projectDeadline) > 0 ? Number(projectDeadline) : 0}
              setValue={(num: number) => setProjectDeadline(num > 0 ? new Date(num) : new Date(0))}
              selectedOption={projectDeadlineOption}
              setSelectedOption={setProjectDeadlineOption}
              open={openFilters.projectDeadline}
              setOpen={enableAndResetFilters}
              title={FILTERS.projectDeadline.label}
            />
          </div>

          {/* 12. Offered Gratification */}
          <div className={`filter-box-container ${offeredGratification.length > 0 ? 'selected' : ''}`}>
            <OfferredGratification
              pickedOptions={offeredGratification}
              setPickedOptions={setOfferedGratification}
              show={openFilters.offeredGratification}
              setShow={enableAndResetFilters}
              displayColumn={true}
              title={FILTERS.offeredGratification.label}
            />
          </div>

          {/* 13. For Gratification */}
          <div className={`filter-box-container ${forGratification.length > 0 ? 'selected' : ''}`}>
            <ForGratification
              pickedOptions={forGratification}
              setPickedOptions={setForGratification}
              show={openFilters.forGratification}
              setShow={enableAndResetFilters}
              displayColumn={true}
              title={FILTERS.forGratification.label}
            />
          </div>

          {/* 14. BizOrTechRole */}
          {/* Usuń całą sekcję BizOrTechRole z layoutu */}
        </div>
        {/* Przyciski Apply i Clear Filters */}
        <div className="filter_buttons">
          <button className="apply_button" onClick={applyFilters}>
            Apply Filters
          </button>
          <button className="clear_filters" onClick={clearFilters}>
            Clear Filters
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProjectFilters;